import React from 'react';

import { Container } from '../../styles/GlobalStyles';
import SideBar from '../../components/SideBar';

export default function Page404() {
  return (
    <Container>

      <SideBar />

      <h1>Essa Página não existe</h1>
    </Container>
  );
}
